import { apiService } from "./index";

const surveyService = {
  get(id) {
    return apiService.get(`/surveys/${id}`);
  },
};

export { surveyService };
